import config from '@/app/editor/config/index';
import store from '@/app/store/store';

store.onChange('__shop', () => {
  const shop = store.getValue('__shop');
  if (shop) {
    if (config.isProduction()) {
      // production
    } else if (!config.isDev()) {
      // staging
    } else {
      // local
      // intercom(shop);
      // upScope(shop);
      // fullstory(shop);
      // require("@/app/editor/wapper/tracking/google-analytics.js")
      // require("@/app/editor/wapper/tracking/fb-pixel.js")
      // require("@/app/editor/wapper/tracking/hotjar.js")
    }
  }
});
